import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { gql } from '@apollo/client';
/**
 * ========== QUERIES ==========
 */

/**
 * Query to fetch user data which is not already provided
 * TODO: OPTIMIZATION (ME-9502) - make this query dynamic as to fetch only the data
 * which is not already provided in props
 */

export var GET_USER_DATA = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query HeaderDynamicData {\n    userProfile {\n      uuid\n      email\n      emailShow\n      avatar\n      fname: firstName\n      lname: lastName\n    }\n    cartCount\n  }\n"])));
export var GET_USER_DATA_RETRO_FIT = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query HeaderDynamicDataRetroFit {\n    userProfile {\n      uuid\n      email\n      emailShow\n      avatar\n      fname: firstName\n      lname: lastName\n    }\n    cartCount\n    userCourses {\n      courseDashboardUrl\n      courseName\n      courseUuid\n    }\n  }\n"])));
/**
 * ========== MUTATIONS ==========
 */
// Mutation to sign out the user

export var SIGN_OUT_USER = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation SignOutUser {\n    signout {\n      success\n    }\n  }\n"])));
export var GET_NAV_ELIGIBILITY = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query HeaderNavEligibility {\n    subsEligibility {\n      cspBuy\n      cspUpgrade\n    }\n  }\n"])));